import React from "react";

export const FieldsProperty = {
  propertyName: "Fields",
  propertyDisplay: "Fields",
  propertyType: "array",
  propertyCategory: "Data",
  renderer: function ({ handlePropertyChange, currentPropertyValues }) {
    const FieldsPropertyInput = React.lazy(() =>
      import("../../Common/GalleryConstructor/FieldsPropertyInput")
    );

    return (
      <React.Suspense fallback={<div>Loading...</div>}>
        <FieldsPropertyInput
          handlePropertyChange={handlePropertyChange}
          currentPropertyValues={currentPropertyValues || []}
        />
      </React.Suspense>
    );
  },
};
